export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    creationDate = "",
    sheetNumber = "",
    materialName = "",
    materialUnit = "",
    materialCode = "",
    details = [],
    totalInQuantity = 0,
    totalOutQuantity = 0,
    closingBalance = 0,
    totalPages = "",
    openingDate = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let tableRows = details.map((item) => `
    <tr>
      <td class="border text-center">${item.ordinalNumber || ""}</td>
      <td class="border text-center">${item.docDate || ""}</td>
      <td class="border text-center">${item.inDocNumber || ""}</td>
      <td class="border text-center">${item.outDocNumber || ""}</td>
      <td class="border px-1">${item.description || ""}</td>
      <td class="border text-center">${item.transactionDate || ""}</td>
      <td class="border text-right px-1">${fmt(item.inQuantity)}</td>
      <td class="border text-right px-1">${fmt(item.outQuantity)}</td>
      <td class="border text-right px-1">${fmt(item.balance)}</td>
      <td class="border px-1">${item.accountantConfirm || ""}</td>
    </tr>
  `).join("");

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 11px; color: black; line-height: 1.4;">
      <table width="100%">
        <tr>
          <td width="50%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="50%" align="center">
            <div class="font-bold">Mẫu số S12-DN</div>
            <div style="font-style: italic; font-size: 10px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 20px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 18px;">THẺ KHO (SỔ KHO)</h2>
        <div style="margin-top: 10px;">Ngày lập thẻ: <span class="dotted-line">${creationDate}</span></div>
        <div style="margin-top: 5px;">Tờ số: <span class="dotted-line">${sheetNumber}</span></div>
      </div>

      <div style="margin-bottom: 15px;">
        <div>- Tên, nhãn hiệu, quy cách vật tư: <span class="dotted-line">${materialName}</span></div>
        <div>- Đơn vị tính: <span class="dotted-line">${materialUnit}</span></div>
        <div>- Mã số: <span class="dotted-line">${materialCode}</span></div>
      </div>

      <table class="table-full" width="100%" style="border-collapse: collapse; margin-top: 10px;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="40">Số TT</th>
            <th class="border" rowspan="2" width="80">Ngày, tháng</th>
            <th class="border" colspan="2">Số hiệu chứng từ</th>
            <th class="border" rowspan="2">Diễn giải</th>
            <th class="border" rowspan="2" width="80">Ngày nhập, xuất</th>
            <th class="border" colspan="3">Số lượng</th>
            <th class="border" rowspan="2" width="100">Ký xác nhận của kế toán</th>
          </tr>
          <tr>
            <th class="border" width="60">Nhập</th>
            <th class="border" width="60">Xuất</th>
            <th class="border" width="60">Nhập</th>
            <th class="border" width="60">Xuất</th>
            <th class="border" width="60">Tồn</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">D</th>
            <th class="border">E</th>
            <th class="border">F</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3</th>
            <th class="border">G</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows}
          <tr style="font-weight: bold; background-color: #fafafa;">
            <td class="border text-center" colspan="6">Cộng cuối kỳ</td>
            <td class="border text-right px-1">${fmt(totalInQuantity)}</td>
            <td class="border text-right px-1">${fmt(totalOutQuantity)}</td>
            <td class="border text-right px-1">${fmt(closingBalance)}</td>
            <td class="border text-center">X</td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top: 20px;">
        <div>- Sổ này có <span class="dotted-line">${totalPages}</span> trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: <span class="dotted-line">${openingDate}</span></div>
      </div>

      <table width="100%" style="margin-top: 30px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 11px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 60px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>

      <style>
        .border { border: 1px solid black; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .px-1 { padding: 4px; }
        .table-full { border: 1px solid black; }
        .dotted-line { border-bottom: 1px dotted black; padding: 0 10px; }
      </style>
    </div>
  `;
};
